import { AuditMatch } from '@app/modules/audit/modules/station-audit/types';
import { ScheduleStatusReportItem } from '@mi-front/core';
import { Dialog, DialogContent, Stack } from '@mui/material';
import { UseQueryResult } from '@tanstack/react-query';
import { hasPossibleUnmatchedMatches } from './schedule-status-spot-utils';
import { ScheduleStatusSpotDetailHeader } from './ScheduleStatusSpotDetailHeader';
import { ScheduleStatusSpotDetailMetadata } from './ScheduleStatusSpotDetailMetadata';
import { ScheduleStatusSpotDetailSchedules } from './ScheduleStatusSpotDetailSchedules';
import { ScheduleStatusSpotDetailUnmatchedMatches } from './ScheduleStatusSpotDetailUnmatchedMatches';

/**
 * Detail dialog for a grouped customId: coverage in the header, metadata,
 * one schedule-to-match table, and extra airings only when they exist.
 */
export function ScheduleStatusSpotDetailDialog(p: {
  item: ScheduleStatusReportItem | null;
  matchesQuery: UseQueryResult<readonly AuditMatch[], unknown>;
  onHide: () => void;
}) {
  if (!p.item) {
    return null;
  }

  return (
    <Dialog open={!!p.item} onClose={p.onHide} maxWidth="md" fullWidth scroll="paper">
      <ScheduleStatusSpotDetailHeader item={p.item} onHide={p.onHide} />
      <DialogContent dividers>
        <Stack spacing={3}>
          <ScheduleStatusSpotDetailMetadata item={p.item} />
          <ScheduleStatusSpotDetailSchedules schedules={p.item.schedules} />
          {hasPossibleUnmatchedMatches(p.item.status) && (
            <ScheduleStatusSpotDetailUnmatchedMatches matchesQuery={p.matchesQuery} />
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
